var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "head-border" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("img", {
              staticClass: "logo_img",
              attrs: { src: require("@/assets/img/shopvidi_logo.png") },
              on: { click: _vm.gotoShopvidi }
            }),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c("div", { staticClass: "header-content" }, [
              _vm._v("Wholesale Partner Program")
            ])
          ],
          1
        ),
        _vm._v(" "),
        !_vm.login
          ? _c("div", { staticClass: "header-action" }, [
              _c(
                "div",
                { staticClass: "action black", on: { click: _vm.gotoLogin } },
                [_vm._v("Login")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action", on: { click: _vm.gotoRegister } },
                [_vm._v("Sign Up")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home_main" },
        [
          _c("div", { staticClass: "home_main1" }, [
            _c("div", { staticClass: "home_main1_content" }, [
              _c("div", { staticClass: "home_main1_content_left" }, [
                _c("div", { staticClass: "home_main1_content_text" }, [
                  _vm._v("Together we grow Expanding your business")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "home_main1_content_action",
                    on: { click: _vm.gotoRegister }
                  },
                  [_vm._v("Join Now")]
                )
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "home_main_2" }, [
            _c("div", { staticClass: "home_main_2_title" }, [
              _vm._v("Proven high sell-through brands")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_2_sub_title" }, [
              _vm._v(
                "Give wholesale partners access to proven high sell-through feature brands with competitive wholesale prices"
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "brands-swiper" },
              [
                _c(
                  "awesome-swiper",
                  {
                    attrs: {
                      pagination: true,
                      turnPages: _vm.turnPages,
                      swiperData: _vm.store,
                      prevName: "topbrands",
                      nextName: "topbrands"
                    }
                  },
                  _vm._l(_vm.brandList, function(e, i) {
                    return _c("swiper-slide", { key: i }, [
                      _c(
                        "div",
                        {
                          staticClass: "brands-swiper-list",
                          on: {
                            click: function($event) {
                              return _vm.open(e.seoUrl)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "brands-swiper-img" }, [
                            _c("img", {
                              attrs: { src: e.brandLogoUrl, alt: "" }
                            })
                          ])
                        ]
                      )
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "home_main_4" }, [
            _c("div", { staticClass: "home_main_4_title" }, [
              _vm._v("How to join us")
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "home_main_4_action",
                on: { click: _vm.gotoRegister }
              },
              [_vm._v("Join Now")]
            )
          ]),
          _vm._v(" "),
          _c("home-footer")
        ],
        1
      ),
      _vm._v(" "),
      _c("register-dialog", {
        attrs: { loginVisible: _vm.loginVisible, type: _vm.type },
        on: { backVisible: _vm.backVisible, changeForm: _vm.changeForm }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home_main1_content_right" }, [
      _c("img", { attrs: { src: require("@/assets/img/home/wpp1_2.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home_main1_content_mobile" }, [
      _c("img", { attrs: { src: require("@/assets/img/home/wpp1_2.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home_main_border" }, [
      _c("div", { staticClass: "home_main_3" }, [
        _c("div", { staticClass: "home_main_3_title" }, [
          _vm._v("Our advantage")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "home_main_3_row" }, [
          _c("div", { staticClass: "home_main_3_row_sub" }, [
            _c("div", { staticClass: "home_main_3_row_sub_img" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/home/wpp3_1.png") }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_title" }, [
              _vm._v("Proven high sell-through brands")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_text" }, [
              _vm._v(
                "Access to worldwide trusted independent brands, with significantly high gross profit margin, and you can try our selected sample kit before bulk purchasing"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "home_main_3_row_sub" }, [
            _c("div", { staticClass: "home_main_3_row_sub_img" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/home/wpp3_2.png") }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_title" }, [
              _vm._v("Free CRM tools")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_text" }, [
              _vm._v(
                "Manage sales, receive and track order, stay connected with customers, and perform activities analysis"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "home_main_3_row" }, [
          _c("div", { staticClass: "home_main_3_row_sub" }, [
            _c("div", { staticClass: "home_main_3_row_sub_img" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/home/wpp3_3.png") }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_title" }, [
              _vm._v("Dedicated Cilent Manager")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_text" }, [
              _vm._v(
                "Support from local Client Experience Manager, to listen to you closely and satisfy your needs with our ShopVidi platform."
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "home_main_3_row_sub" }, [
            _c("div", { staticClass: "home_main_3_row_sub_img" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/home/wpp3_4.png") }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_title" }, [
              _vm._v("ViDirect Plan")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home_main_3_row_sub_text" }, [
              _vm._v(
                "Help you reaching more customers and boosting the revenue via ShopVidi’s nationwide sales leads"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home_main_4_img" }, [
      _c("img", { attrs: { src: require("@/assets/img/home/wpp4_1.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f096076c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f096076c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/homepage.vue
// module id = SSEv
// module chunks = 2